import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from './Logo';

type LegalLayoutProps = {
  children: React.ReactNode;
};

const LegalLayout: React.FC<LegalLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex-1 bg-background flex flex-col">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <Logo className="text-primary mr-3" width={40} height={40} />
            <span className="text-xl font-extrabold text-text-dark">
              Comfort{' '}
              <span className="bg-gradient-to-r from-primary-light to-primary bg-clip-text text-transparent">
                Dry Eye App
              </span>
            </span>
          </Link>
          <Link
            to="/"
            className="flex items-center text-primary hover:text-primary-dark transition-colors font-medium min-h-11"
          >
            <ArrowLeft className="w-5 h-5 mr-2" aria-hidden="true" />
            Back to Home
          </Link>
        </div>
      </header>

      <main id="main-content" className="flex-1 w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {children}
      </main>

      <footer className="bg-text-dark py-8 mt-auto">
        <nav
          aria-label="Legal"
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-3"
        >
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            <Link to="/privacy" className="text-gray-400 hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-white">
              Terms of Use
            </Link>
            <Link to="/accessibility" className="text-gray-400 hover:text-white">
              Accessibility
            </Link>
            <Link to="/disclaimers" className="text-gray-400 hover:text-white">
              Disclaimers
            </Link>
          </div>
          <p className="text-gray-400 text-sm">
            © 2026 Dry Eye Solutions Ltd. All rights reserved.
          </p>
        </nav>
      </footer>
    </div>
  );
};

export default LegalLayout;
